import { Typography } from '@mui/material';

/**
 * Consistent rendering for a signed performance number.
 * value is a plain number — positive → green, negative → red.
 */
export default function PerformanceValue({
    value,
    format = 'percent',
    variant = 'body2',
    showSign = true,
    fontWeight = 600,
    sx = {},
}) {
    if (value == null || Number.isNaN(value)) {
        return (
            <Typography variant={variant} sx={{ color: 'text.muted', ...sx }}>
                —
            </Typography>
        );
    }
    const positive = value >= 0;
    const sign = showSign && positive ? '+' : '';
    const formatted =
        format === 'percent'
            ? `${sign}${value.toFixed(1)}%`
            : `${sign}${value.toLocaleString()}`;
    return (
        <Typography
            variant={variant}
            sx={{
                fontWeight,
                color: positive ? 'success.main' : 'error.main',
                fontFamily: theme => theme.typography.fontFamilyMono,
                fontFeatureSettings: '"tnum"',
                ...sx,
            }}
        >
            {formatted}
        </Typography>
    );
}
